import * as React from 'react';
import { DateInput, IDateInputValue } from 'ui-toolkit/components/DateInput/DateInput';
import { FormCell } from 'ui-toolkit/components/FormCell/FormCell';
import { DateTime } from 'luxon';
import { IMetadata, IStandardDocument } from '../../../types/order/documents/shared/interfaces';
import { BodyText } from 'ui-toolkit';
import styled from 'styled-components';
import { SpaceWrapper } from 'ui-toolkit';
import {
  DocumentCategoriesByName,
  requiresGoodThroughDate,
} from '../../../types/order/documents/IDocumentCategoryType';

const StyledDocumentData = styled.div`
  //align-content: center;
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
  //min-height: 200px;
  //width: 520px;
`;

export interface IDocumentDataProps {
  document?: Partial<Pick<IStandardDocument, 'category' | 'metadata'>>;
  onChange: (output: IMetadata) => void;
  showInputs?: boolean;
  documentCategoriesByName: DocumentCategoriesByName;
}

export const DocumentData: React.FC<IDocumentDataProps> = ({
  document,
  onChange,
  showInputs,
  documentCategoriesByName,
}) => {
  if (document) {
    if (requiresGoodThroughDate(document.category, documentCategoriesByName)) {
      const good_through_date = document.metadata ? document.metadata.good_through_date || null : null;
      const onGoodThroughDateChange = (value: IDateInputValue) => {
        const good_through_date =
          (value.value && DateTime.fromISO(value.value).isValid
            ? DateTime.fromISO(value.value).toISO()
            : value.value) || undefined;
        onChange({
          ...(document.metadata || {}),
          good_through_date,
        });
      };
      return (
        <StyledDocumentData>
          <SpaceWrapper leftSpace={'none'} rightSpace={'none'}>
            {showInputs ? (
              <DateInput
                label="Good Through Date"
                value={good_through_date}
                onChange={onGoodThroughDateChange}
                isRequired
                zIndex={201} // 200 is used by the Modal itself.
              />
            ) : (
              <FormCell label="Good Through Date">
                {good_through_date ? DateTime.fromISO(good_through_date).toFormat('D') : '-'}
              </FormCell>
            )}
          </SpaceWrapper>
        </StyledDocumentData>
      );
    } else {
      return <BodyText>This document doesn't have editable fields!</BodyText>;
    }
  } else {
    return <></>;
  }
};
